import { useClerk } from "@clerk/clerk-react";
import { useLocalization } from "../../lib/i18n";
import { AppDownloadPrompt } from "./AppDownloadPrompt";
import { StoreBadges } from "./StoreBadges";

type UnauthenticatedWelcomeProps = {
  onSignUp?: () => void
  onSignIn?: () => void
}

export function UnauthenticatedWelcome({ onSignUp, onSignIn }: UnauthenticatedWelcomeProps) {
  const clerk = useClerk();
  const { t } = useLocalization();
  const handleSignUp = () => {
    if (clerk.openSignUp) {
      void clerk.openSignUp();
      return;
    }
    onSignUp?.();
  };
  const handleSignIn = () => {
    if (clerk.openSignIn) {
      void clerk.openSignIn();
      return;
    }
    onSignIn?.();
  };

  return (
    <section className="relative mx-auto flex min-h-[calc(100vh-9rem)] w-full max-w-[1100px] overflow-hidden rounded-none px-4 py-4 md:min-h-[calc(100vh-11rem)] md:py-6 lg:rounded-xl">
      <img
        src="/img/baseball-splash.png"
        alt="Baseball player swinging a bat in a stadium"
        className="absolute inset-0 h-full w-full object-cover"
      />
      <div className="absolute inset-0 bg-[linear-gradient(90deg,rgba(8,10,14,0.92)_0%,rgba(8,10,14,0.72)_42%,rgba(8,10,14,0.24)_100%)]" />
      <div className="absolute inset-x-0 bottom-0 h-36 bg-gradient-to-t from-background via-background/55 to-transparent" />

      <div className="relative z-10 flex w-full items-end pb-8 pt-28 md:items-center md:pb-10 md:pt-10">
        <div className="max-w-[560px] lg:pl-[72px]">
          <p className="font-display text-sm font-bold uppercase tracking-[0.18em] text-white/82 md:text-base">
            {t("home.welcome.context")}
          </p>
          <h1 className="mt-3 max-w-[11ch] font-display text-[46px] font-bold uppercase leading-[0.96] text-[#F5A623] md:text-[72px]">
            {t("home.welcome.emphasis")}
          </h1>
          <p className="mt-5 max-w-lg text-base font-semibold leading-7 text-white md:text-xl md:leading-8">
            {t("home.welcome.body")}
          </p>

          <div className="mt-7 flex flex-col gap-3 sm:max-w-[360px]">
            <AppDownloadPrompt />

            <button
              type="button"
              onClick={handleSignUp}
              className="min-h-12 rounded-lg bg-[#F5A623] px-8 py-[14px] text-center font-display text-sm font-bold uppercase text-black transition-opacity hover:opacity-90"
            >
              {t("home.welcome.createPool")}
            </button>

            <button
              type="button"
              onClick={handleSignIn}
              className="text-left text-sm font-bold text-white/82 transition-colors hover:text-white"
            >
              {t("guest.auth.alreadyHaveAccountSignIn")}
            </button>

            <StoreBadges className="pt-2" />
          </div>
        </div>
      </div>
    </section>
  )
}
